import { parseNote, type ReleaseNote } from "@vidario/domain";

// Release Notes for "What's new" (ADR 0005), bundled at build time from
// content/whats-new/*.md, so a note goes live with the release that brings
// its code. A broken note throws here; whats-new-notes.test.ts runs this in
// frontend CI, so it fails the PR instead of the app.
const SOURCES = import.meta.glob<string>("../../content/whats-new/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
});

export const RELEASE_NOTES: ReleaseNote[] = Object.entries(SOURCES)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([path, source]) => parseNote(path.split("/").pop() ?? path, source));
